import React, { useEffect, useState, VFC } from 'react';
import styled from 'styled-components';
import CircularProgress from '@material-ui/core/CircularProgress';

interface Props {
  url: string;
  onLoad?: () => void;
}
const IframeComponent: VFC<Props> = ({ url, onLoad }: Props) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(false);
  }, [url]);

  const loadCompleted = () => {
    setLoaded(true);
    onLoad?.();
  };

  return (
    <IframeWrapper>
      {!loaded && <CircularProgress />}
      <Iframe src={url} onLoad={loadCompleted} loaded={loaded} />
    </IframeWrapper>
  );
};

export default IframeComponent;

const IframeWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;
const Iframe = styled.iframe<{ loaded: boolean }>`
  display: ${({ loaded }) => (loaded ? 'block' : 'none')};
  width: 100%;
  height: 100%;
`;
